module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 box"
  }, [_c('div', {
    staticClass: "roomTitle"
  }, [(_vm.loading) ? _c('span', [_vm._v(" Loading... " + _vm._s(_vm.roomName))]) : (!_vm.loading && _vm.roomName) ? _c('span', [_vm._v(" Connected to " + _vm._s(_vm.roomName))]) : _c('span', [_vm._v("Select a room to get started")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "spacing"
  }), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row remote_video_container"
  }, [_c('div', {
    attrs: {
      "id": "remoteTrack"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "localTrack"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6897ce12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/twillo/Video.vue
// module id = 724
// module chunks = 1